import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { filter, map, pipe } from 'rxjs';

import { AppSettings, defaultInputMode } from 'app/features/settings/models/app-settings';
import { AppSettingsState, settingsFeatureKey } from 'app/state/settings/settings.reducer';

export const selectSettingsState = createFeatureSelector<AppSettingsState>(settingsFeatureKey);

export const selectAppSettings = createSelector(selectSettingsState, (state) => state.settings);

export const selectAppSettingsIfDefined = pipe(
    select(selectAppSettings),
    filter((settings): settings is AppSettings => !!settings),
);

export const selectAppMode = createSelector(selectAppSettings, (state) => state?.appMode);

export const selectAppModeIfDefined = pipe(
    selectAppSettingsIfDefined,
    map((settings) => settings.appMode),
);

export const selectScanFlowRegistrationSubmitIntervalMsIfDefined = pipe(
    selectAppSettingsIfDefined,
    map((settings) => settings.scanFlowRegistrationSubmitIntervalMs),
);

export const selectInputModeIfDefined = pipe(
    selectAppSettingsIfDefined,
    map((settings) => (settings.inputModes.length ? settings.inputModes[0] : defaultInputMode)),
);

export const areSettingsLoaded = createSelector(selectSettingsState, (state) => {
    return !!state.settings;
});

export const selectIsScanFlowAllowedIfDefined = pipe(
    selectAppSettingsIfDefined,
    map(
        (settings) =>
            settings.appMode === 'personal' &&
            settings.inputModes.some((inputMode) => ['barcode', 'nfc'].includes(inputMode)),
    ),
);
